








import { Component, Vue } from 'vue-property-decorator';

@Component
export default class reCaptchaBranding extends Vue {
  private openExternalUrl (url: string) {
    window.open(url, '_blank', 'noopener');
  }
}
